import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-contacts-page',
  templateUrl: './contacts-page.component.html',
  styleUrls: ['./contacts-page.component.scss']
})
export class ContactsPageComponent implements OnInit {
  constructor(
    public authService: AuthService,
    private readonly toastrService: ToastrService,
    private readonly clipboardService: ClipboardService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {}

  onCopyText(copyText: string) {
    this.clipboardService.copy(copyText);
    this.toastrService.success(this.translate.instant('messages.copied_clipboard'));
  }
}
